import { METHOD_TYPE, CommonApiOptions } from "../constants/api";
import configs from "../configs/apiConfigs";
import { commonApi } from "../helpers/api";
import { attachHeader } from "../utils/apiHandler";

export interface AcquisitionSummaryParams {
  clinicUniqueId: string;
  startDate: string;
  endDate: string;
}

export const fetchAcquisitionSummary = (params: AcquisitionSummaryParams) => {
  const request: CommonApiOptions = {
    url: `${configs.API_URL}acquisitionsummery/${params.clinicUniqueId}/?startDate=${params.startDate}&endDate=${params.endDate}`,
    method: METHOD_TYPE.GET,

    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
    // body: {
    //   type: BODY_TYPE.RAW,
    //   data: params
    // }
  };
  return commonApi(request);
};


